/**
 * Collection story hero — Read More expand (Framer Content PCP / framer-v3EOW).
 * Variant tween: delay 0, duration 0.6s, ease [0.12, 0.23, 0.5, 1].
 */
(function () {
  const LINE_HEIGHT_PX = 16;
  const CLIP_PADDING_BOTTOM_PX = 10;
  const EXPAND_MS = 600;

  function getLineCap(root) {
    const raw = getComputedStyle(root).getPropertyValue('--wbs-cth-lines').trim();
    const lines = parseFloat(raw);
    return Number.isFinite(lines) ? lines : 27;
  }

  /*
    Framer's closed variant is the first two paragraphs only, ending at
    "nowhere else to go." The block is as tall as that text, so it shortens
    when the window gets wider inside the same breakpoint. A fixed line count
    stays tall and lets the next paragraph show through.
  */
  function getExcerptEnd(body) {
    const paragraphs = Array.prototype.filter.call(body.querySelectorAll('p'), function (paragraph) {
      return paragraph.textContent.trim().length > 0;
    });
    return paragraphs[1] || paragraphs[0] || null;
  }

  function getCollapsedClipHeight(root) {
    const body = root.querySelector('[data-wbs-read-more-body]');
    const clip = root.querySelector('[data-wbs-read-more-clip]');
    const end = body && getExcerptEnd(body);
    if (!end || !clip) {
      return getLineCap(root) * LINE_HEIGHT_PX + CLIP_PADDING_BOTTOM_PX;
    }
    const clipTop = clip.getBoundingClientRect().top;
    const endBottom = end.getBoundingClientRect().bottom;
    return Math.ceil(endBottom - clipTop) + CLIP_PADDING_BOTTOM_PX;
  }

  function initHero(root) {
    const body = root.querySelector('[data-wbs-read-more-body]');
    const clip = root.querySelector('[data-wbs-read-more-clip]');
    const toggle = root.querySelector('[data-wbs-read-more-toggle]');
    const fade =
      root.querySelector('.wbs-collection-story-hero__fade') ||
      root.querySelector('.wbs-collection-tanja-hero__fade');
    if (!body || !clip || !toggle) return;

    function syncReadMoreVisibility() {
      if (root.classList.contains('is-expanded') || root.classList.contains('is-expanding')) return;
      const collapsed = getCollapsedClipHeight(root);
      const excerptEnd = getExcerptEnd(body);
      let more = false;
      let sibling = excerptEnd && excerptEnd.nextElementSibling;
      while (sibling) {
        if (sibling.textContent.trim()) {
          more = true;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
      const needsToggle = more;
      root.classList.toggle('is-read-more-hidden', !needsToggle);
      clip.style.maxHeight = needsToggle ? collapsed + 'px' : '';
    }

    function finishExpand() {
      root.classList.remove('is-expanding', 'is-read-more-fading');
      root.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');
      clip.style.maxHeight = '';
      clip.style.transition = '';
    }

    function expandReadMore() {
      if (root.classList.contains('is-expanded') || root.classList.contains('is-expanding')) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finishExpand();
        return;
      }

      root.classList.add('is-expanding');
      const fromHeight = getCollapsedClipHeight(root);
      const toHeight = body.scrollHeight + CLIP_PADDING_BOTTOM_PX;

      clip.style.transition = 'none';
      clip.style.maxHeight = fromHeight + 'px';
      clip.offsetHeight;

      clip.style.transition = '';
      clip.style.maxHeight = toHeight + 'px';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-read-more-fading');
        });
      });

      let done = false;
      const complete = () => {
        if (done) return;
        done = true;
        clip.removeEventListener('transitionend', onTransitionEnd);
        finishExpand();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== clip || event.propertyName !== 'max-height') return;
        complete();
      };

      clip.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(complete, EXPAND_MS + 80);
    }

    toggle.addEventListener('click', expandReadMore);

    syncReadMoreVisibility();
    window.addEventListener('resize', syncReadMoreVisibility);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncReadMoreVisibility);
    }
  }

  function init() {
    document
      .querySelectorAll('[data-wbs-collection-story-hero], [data-wbs-collection-tanja-hero]')
      .forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
